function GetLocalTimestamp(arg) {
    var date = new Date();
    var day = date.getDate();       // yields date
    var month = date.getMonth() + 1;    // yields month (add one as '.getMonth()' is zero indexed)
    var year = date.getFullYear();  // yields year
    var hour = date.getHours();     // yields hours 
    var minute = date.getMinutes(); // yields minutes
    var second = date.getSeconds(); // yields seconds

    // After this construct a string with the above results as below
    var time = day + "/" + month + "/" + year + " " + hour + ':' + minute + ':' + second; 
    return time;
}

function TGetYear(arg) {
    return new Date().getFullYear();
}

function TGetMonth(arg) {
    return new Date().getMonth() + 1;
}

function TGetDate(arg) {
    return new Date().getDate();
}

function TGetHour(arg) {
    return new Date().getHours();
}

function TGetMinute(arg) {
    return new Date().getMinutes();
}

function TGetSeconds(arg) {
    return new Date().getSeconds();
}

function TWriteLine(arg) {
    console.log(arg);
}